module.exports = __webpack_public_path__ + "static/media/thumb_GuardSignature_503x503.870f18f8.jpg";